import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";

export const getAppsApi = () => {
  return axios.get(getBaseURL() + ENDPOINTS.APPS_LIST, {
    headers: getHeaders(),
  });
};
